export default __webpack_public_path__ + "static/media/cart.19079d58.svg";